__webpack_require__.p = "/simple-word-play/";